/**
 * Index de la prestation ouverte après la suppression de la prestation `removedIndex`.
 *
 * On reste sur la même prestation : si elle était après celle supprimée, son index
 * baisse de 1. Si on supprime celle qui est ouverte, on ouvre la précédente
 * (ou la première). Partagé par le reducer REMOVE_ORDER et la mise à jour de
 * `?order_index=` dans l'URL, qui doivent donner le même résultat.
 */
export const indexAfterRemoval = (currentIndex, removedIndex, remainingCount) => {
  if (remainingCount <= 0) {
    return null;
  }
  const current = currentIndex === null || currentIndex === undefined
    ? null
    : parseInt(currentIndex, 10);
  let next;
  if (current === null || Number.isNaN(current) || current === removedIndex) {
    next = removedIndex - 1;
  } else if (current > removedIndex) {
    next = current - 1;
  } else {
    next = current;
  }
  return Math.min(Math.max(next, 0), remainingCount - 1);
};
